import jsPDF from "jspdf";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import QRCode from "qrcode";

export const DhlFooter = async (
  params: {
    doc: jsPDF | any;
    bookingType: string;
    accountType: string;
    data: PrintDataEntitas;
    pieceData: any;
    barcode: string;
    vendorRefCode: string;
    barcodeValue: string;
    vendorRefCodeValue: string;
    logo: string;
    shipmentId: string;
    startX: number;
    startY: number;
  },
  translate: Function
) => {
  const {
    deliveryConfirmationNo,
    deliveryDepotCode,
    primarySortCode,
    productCode,
    secondarySortCode
  } = params.data.vendorDl;

  const qrcode = await QRCode.toDataURL(deliveryConfirmationNo || "", {
    errorCorrectionLevel: "Q"
  }).then((url: string) => {
    return url;
  });

  const leftMargin = 4;

  const width = params.doc.internal.pageSize.getWidth();
  const height = params.doc.internal.pageSize.getHeight();

  // lines
  const widthCol1 = (35 / 100) * width; // 35% bottom
  const widthCol2 = params.startX;

  const startY = params.startY;
  const startY8 = (97 / 100) * height; // 74% horizontal8
  const spaceY6 = startY8 - startY;
  const startY7 = startY + spaceY6 / 2; // 74% horizontal6

  params.doc.setFont("Montserrat", "bold");
  params.doc.setTextColor("#333333");

  // vertical
  params.doc.line(widthCol1, startY, widthCol1, startY8);
  params.doc.line(widthCol2, startY, widthCol2, startY8);

  // horizontal
  params.doc.line(0, params.startY, widthCol2, params.startY);
  params.doc.line(0, startY7, widthCol2, startY7);
  params.doc.line(0, startY8, width, startY8);

  // section ROW 4 COL 1
  // PDO
  const spaceRow4Col1 = startY7 - startY;
  const startYPdo = startY + (60 / 100) * spaceRow4Col1;
  params.doc.setFontSize(18);
  params.doc.text(productCode, leftMargin, startYPdo);

  const spaceRow4Col2 = startY7 - startY;
  const startYB13 = startY + (60 / 100) * spaceRow4Col2;
  params.doc.text(secondarySortCode, widthCol1 + leftMargin, startYB13);

  const spaceRow5Col1 = startY8 - startY7;
  const startYMYPCH1 = startY7 + (60 / 100) * spaceRow5Col1;
  params.doc.text(deliveryDepotCode, leftMargin, startYMYPCH1);

  const spaceRow5Col2 = startY8 - startY7;
  const startYCen1 = startY7 + (60 / 100) * spaceRow5Col2;
  params.doc.text(primarySortCode, widthCol1 + leftMargin, startYCen1);

  // QR CODE
  const marginQrCode = 0.25;
  const spaceRow45Col3 = startY8 - startY - marginQrCode * 2;
  const qrWidth = width - widthCol2;
  const qrHeight = qrWidth;
  const startYQrCode =
    startY + marginQrCode + spaceRow45Col3 / 2 - qrHeight / 2;
  params.doc.addImage(
    qrcode,
    "PNG",
    widthCol2 + marginQrCode,
    startYQrCode,
    qrWidth,
    qrHeight,
    deliveryConfirmationNo,
    "FAST",
    0
  );

  params.doc.setTextColor("#333333");
  params.doc.setFontSize(5);

  const snkPositionY = height - 2;
  params.doc.setFont("Montserrat", "normal");
  params.doc.text(translate("receipt.terms"), leftMargin, snkPositionY);
  params.doc.text(
    translate("receipt.info"),
    width - leftMargin,
    snkPositionY,
    null,
    null,
    "right"
  );

  return {
    ...params,
    startX: 0
  };
};
